/**
 * Room service constants — layouts and equipment for the Book Meeting panel.
 *
 * Layout capacity adjustments (capAdj) are deltas relative to the room's
 * base capacity. Setup/reset times indicate facilities team involvement.
 *
 * Icon names reference keys in ICON_REGISTRY used by <paper-icon>.
 */

// ── Room Layouts ───────────────────────────────────────

export interface RoomLayout {
  /** Unique identifier (used as the layout selection value) */
  id: string;
  /** Display name */
  name: string;
  /** Lucide icon name for PaperIconComponent */
  icon: string;
  /** Capacity delta vs room's base capacity */
  capAdj: number;
  /** Setup time in minutes (facilities prep before meeting) */
  setupMin: number;
  /** Reset time in minutes (facilities teardown after meeting) */
  resetMin: number;
}

export const ROOM_LAYOUTS: RoomLayout[] = [
  { id: 'boardroom', name: 'Boardroom', icon: 'square',        capAdj: 0,  setupMin: 10, resetMin: 10 },
  { id: 'u-shape',   name: 'U-shape',   icon: 'shapes',        capAdj: -2, setupMin: 30, resetMin: 20 },
  { id: 'theatre',   name: 'Theatre',   icon: 'rows-3',        capAdj: +4, setupMin: 30, resetMin: 15 },
  { id: 'cabaret',   name: 'Cabaret',   icon: 'grid-2x2',      capAdj: +2, setupMin: 45, resetMin: 30 },
  { id: 'cluster',   name: 'Cluster',   icon: 'circle-dashed', capAdj: 0,  setupMin: 15, resetMin: 10 },
  { id: 'standing',  name: 'Standing',  icon: 'user-round',    capAdj: +4, setupMin: 5,  resetMin: 5  },
  { id: 'informal',  name: 'Informal',  icon: 'sofa',          capAdj: -2, setupMin: 0,  resetMin: 0  },
];

// ── Room Equipment ─────────────────────────────────────

export interface RoomEquipment {
  /** Unique identifier (used in the equipment selection array) */
  id: string;
  /** Display name */
  name: string;
  /** Icon name for PaperIconComponent */
  icon: string;
}

export const ROOM_EQUIPMENT: RoomEquipment[] = [
  { id: 'display',    name: 'Display / projector',   icon: 'monitor' },
  { id: 'whiteboard', name: 'Interactive whiteboard', icon: 'presentation' },
  { id: 'flipchart',  name: 'Flip chart',            icon: 'clipboard-list' },
  { id: 'video-bar',  name: 'Video bar',             icon: 'video' },
  { id: 'laptop',     name: 'Laptop lending',        icon: 'laptop' },
  { id: 'mic',        name: 'Additional mics',       icon: 'mic' },
];
